import React from 'react'

var awsPrefix = `https://res302.s3-us-west-2.amazonaws.com/outer201/sailingthegreen/`

const FixedTopHeader = ({ darkenHeader, menuOpen, toggleMenuOpen }) => {
	return(
		<div className={`FlexContainer Row FullWidth Fixed Top Height075 Header ${darkenHeader ? "DarkenedHeader" : ""}`}>
			<div className={`FlexContainer Flex Row AlignCentre FlexStart`}>
				<img src={`${awsPrefix}stg.png`} className={`Width100px SpaceLeftX4`} alt="Sailing the green logo"/>
			</div>
			<div className={`FlexContainer Flex250 Row AlignCentre SpaceBetween SpaceLeftX4 SpaceRightX4 HideMobile`}>
				<a href="#home" className={`aThree White BoldText ExtraSmall`}>HOME</a>
				<a href="#about" className={`aThree White BoldText ExtraSmall`}>WHAT WE DO</a>
				<a href="#technology" className={`aThree White BoldText ExtraSmall`}>TECHNOLOGY</a>
				<a href="#team" className={`aThree White BoldText ExtraSmall`}>OUR TEAM</a>
				<a href="#contact" className={`aThree White BoldText ExtraSmall`}>CONTACT</a>
			</div>
			<div className={`FlexContainer Flex Row AlignCentre JustifyCentre Clickable SuperTop`} onClick={() => toggleMenuOpen(!menuOpen)}>
				{!menuOpen && <img className={`MenuBurger SpaceLeftX8`} src={`${awsPrefix}icons/menu.svg`} alt="menu burger"/>}
			</div>
		</div>
	)
}

export default FixedTopHeader